import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appTabContent]',
    standalone: true,
})
export class TabContentDirective {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public constructor(public templateRef: TemplateRef<any>) {}
}
